import { useContext, useEffect, useState, useRef } from "react";
import { Table, Row, Col, List, Typography, Space, Radio, Select, Tag, Card, Button, message, notification } from "antd"
import moment from "moment";

import { Context } from "../../context";
import { Fetch, Post } from "../../fetch";
import { convertIdToKey } from "../../utils";
const { Column } = Table;
const { Option } = Select;
const { Title, Text } = Typography;

const UploadContentToJio = () => {

    const [moviesMaster, setMoviesMaster] = useState([]);
    const [seriesMaster, setSeriesMaster] = useState([]);
    const [songsMaster, setSongsMaster] = useState([]);
    const [contentType, setContentType] = useState("movies");
    const [movies, setMovies] = useState([]);
    const [series, setSeries] = useState([]);
    const [songs, setSongs] = useState([]);
    const [selectedData, setSelectedData] = useState({
        table1: { keys: [], rows: [] },
        table2: { keys: [], rows: [] },
        table3: { keys: [], rows: [] },
        table4: { keys: [], rows: [] },
    });

    // Get selected items grouped by type
    const [selectedMovies, setSelectedMoviesState] = useState([]);
    const [selectedSeries, setSelectedSeriesState] = useState([]);
    const [selectedSongs, setSelectedSongsState] = useState([]);

    const getRowSelection = (tableName) => ({
        selectedRowKeys: selectedData[tableName].keys,

        onChange: (keys, rows) => {
            setSelectedData((prev) => ({
                ...prev,
                [tableName]: {
                    keys,
                    rows,
                },
            }));
        },
        onSelect: (record, selected, selectedRows) => {

            if (selected) {
                if (contentType === "movies") {
                    setSelectedMoviesState((prev) => [...prev, record]);
                } else if (contentType === "series") {
                    setSelectedSeriesState((prev) => [...prev, record]);
                } else if (contentType === "songs") {
                    setSelectedSongsState((prev) => [...prev, record]);
                }
            } else {
                if (contentType === "movies") {
                    setSelectedMoviesState((prev) => prev.filter((item) => item.key !== record.key));
                } else if (contentType === "series") {
                    setSelectedSeriesState((prev) => prev.filter((item) => item.key !== record.key));
                } else if (contentType === "songs") {
                    setSelectedSongsState((prev) => prev.filter((item) => item.key !== record.key));
                }
            }
        },
        onSelectAll: (selected, selectedRows, changeRows) => {

            if (selected) {

                // All rows are selected - replace state with all selectedRows
                if (contentType === "movies") {
                    setSelectedMoviesState(selectedRows);
                } else if (contentType === "series") {
                    setSelectedSeriesState(selectedRows);
                } else if (contentType === "songs") {
                    setSelectedSongsState(selectedRows);
                }
            } else {

                // All rows are deselected - remove all changeRows from state
                if (contentType === "movies") {
                    setSelectedMoviesState((prev) =>
                        prev.filter((item) => !changeRows.some((row) => row.key === item.key))
                    );
                } else if (contentType === "series") {
                    setSelectedSeriesState((prev) =>
                        prev.filter((item) => !changeRows.some((row) => row.key === item.key))
                    );
                } else if (contentType === "songs") {
                    setSelectedSongsState((prev) =>
                        prev.filter((item) => !changeRows.some((row) => row.key === item.key))
                    );
                }
            }
        }

    });

    const { token, apiUrl } = useContext(Context);

    useEffect(() => {
        Fetch(`${apiUrl}/movies`, token, (result) => {
            let movs = convertIdToKey(result.movies);
            movs = movs.filter(movie => movie.availability === "perpetual")
            setMovies(movs);
            setMoviesMaster(movs);
        });
        Fetch(`${apiUrl}/series`, token, (result) => {
            let series = convertIdToKey(result.series);
            series = series.filter(series => series.availability === "perpetual")
            setSeries(series);
            setSeriesMaster(series)
        });

        Fetch(`${apiUrl}/songs`, token, (result) => {
            let songs = convertIdToKey(result.songs);
            songs = songs.filter(song => song.availability === "perpetual")
            setSongs(songs);
            setSongsMaster(songs)
        });
    }, [apiUrl, token]);

    // Track if it's the first render to avoid clearing on initial mount
    const isFirstRender = useRef(true);

    // Clear selections from other content types when switching tabs
    useEffect(() => {

        // Skip clearing on initial mount
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        // Clear selections based on current contentType
        if (contentType === "movies") {

            // Clear series, episodes, songs
            setSelectedData((prev) => ({
                ...prev,
                table2: { keys: [], rows: [] },
                table4: { keys: [], rows: [] },
            }));
            setSelectedSeriesState([]);
            setSelectedSongsState([]);
        } else if (contentType === "series") {

            // Clear movies, episodes, songs
            setSelectedData((prev) => ({
                ...prev,
                table1: { keys: [], rows: [] },
                table4: { keys: [], rows: [] },
            }));
            setSelectedMoviesState([]);
            setSelectedSongsState([]);
        } else if (contentType === "songs") {

            // Clear movies, series, episodes
            setSelectedData((prev) => ({
                ...prev,
                table1: { keys: [], rows: [] },
                table2: { keys: [], rows: [] },
            }));
            setSelectedMoviesState([]);
            setSelectedSeriesState([]);
        }
    }, [contentType]);

    const handleSearchChange = (contentId) => {
        if (contentId === undefined) return;
        Fetch(`${apiUrl}/${contentType}/${contentId}`, token, (result) => {
            const movies = convertIdToKey([result]);
            movies.forEach((movie) => {
                if (typeof movie["genre"] === "string") {
                    movie["genre"] = [movie["genre"]];
                }

                if (!movie.videoUploadDateTime) {
                    movie.videoUploadDateTime = "NA";
                } else {
                    movie.videoUploadDateTime = moment(movie.videoUploadDateTime).format(
                        "DD/MM/YYYY hh:mm A"
                    );
                }

            });
            if (contentType === "movies") {
                setMovies(movies);
            } else if (contentType === "series") {
                setSeries(movies);
            } else if (contentType === "songs") {
                setSongs(movies);
            }
        });
    };

    const handleClearSearch = () => {
        if (contentType === "movies") {
            setMovies(moviesMaster);
        } else if (contentType === "series") {
            setSeries(seriesMaster);
        } else if (contentType === "songs") {
            setSongs(songsMaster);
        }
    }

    const handleSubmit = async () => {

        // Validate that only one content type is selected
        const hasMovies = selectedMovies.length > 0;
        const hasSeries = selectedSeries.length > 0;
        const hasSongs = selectedSongs.length > 0;

        const selectedTypesCount = [hasMovies, hasSeries, hasSongs].filter(Boolean).length;

        // If no types are selected
        if (selectedTypesCount === 0) {
            message.error("Please select at least one item to submit");
            return;
        }

        // If more than one type is selected
        if (selectedTypesCount > 1) {
            message.error("Please select items from only one content type at a time");
            return;
        }

        //format the content
        const contentData = {};
        if (hasMovies) {
            contentData.content_type = "movie";
            const listOfMoviesIds = selectedMovies.map((movie) => movie.key);
            contentData.content_ids = listOfMoviesIds;
        }

        if (hasSeries) {
            contentData.content_type = "webseries";
            const listOfSeriesIds = selectedSeries.map((series) => series.key);
            contentData.content_ids = listOfSeriesIds;
        }

        if (hasSongs) {
            contentData.content_type = "music";
            const listOfSongsIds = selectedSongs.map((song) => song.key);
            contentData.content_ids = listOfSongsIds;
        }

         // Validate content_ids length before API call
         if (contentData.content_ids && contentData.content_ids.length > 100) {
            notification.error({
                message: 'Validation Error',
                placement: 'topRight',
                duration: 0,
                description: (
                    <div>
                        <div style={{ marginBottom: 8 }}>
                            <strong>Field:</strong> <code>content_ids</code>
                        </div>
                        <div style={{ marginLeft: 8, color: '#ff4d4f' }}>
                            <strong>Error:</strong> Number of contents cannot exceed 100 items. You have selected {contentData.content_ids.length} items.
                        </div>
                        <div style={{ marginTop: 8, fontSize: '12px', color: '#999' }}>
                            Please reduce the selection to 100 items or less.
                        </div>
                    </div>
                ),
            });
            return;
        }

        Post(`${apiUrl}/jio-cms/sync-content`, token, contentData, (result) => {
            if (result.success === true) {
                message.success("Content uploaded successfully to JIO CMS");
            } else {
                if (result?.errors?.length > 0) {
                    notification.error({
                        message: 'Upload Failed',
                        placement: 'topRight',
                        duration: 0,
                        description: (
                            <div>
                                {result.errors.map((err) => (
                                    <div
                                        key={err.contentId}
                                        style={{ marginBottom: 12 }}
                                    >
                                        <div>
                                            <strong>contentName:</strong>
                                        </div>
                                        <div style={{ marginLeft: 8 }}>
                                            {err.contentName}
                                        </div>
                                        <div style={{ marginTop: 4 }}>
                                            <strong>Error:</strong>
                                        </div>
                                        <div style={{ marginLeft: 8 }}>
                                            {err.errorMessage}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ),
                    });
                }
            }
        }, (error) => {
            message.error(error);
        });
    }

    return (
        <div className="add-content-wrapper">
            <h3 className="">Upload Content to Jio</h3>
            <Space direction="vertical" style={{ width: "100%" }}>
                <Radio.Group
                    className="content-type-option"
                    value={contentType}
                    onChange={(e) => {
                        setContentType(e.target.value);
                    }}>
                    <Radio value="movies">Movie</Radio>
                    <Radio value="series">Series</Radio>
                    <Radio value="songs">Song</Radio>
                </Radio.Group>
                <Select
                    placeholder={`Search ${contentType}`}
                    showSearch
                    allowClear
                    onChange={handleSearchChange}
                    onClear={handleClearSearch}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                        optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                    }
                    style={{ width: "100%" }}
                >
                    {contentType === "movies" &&
                        moviesMaster.map((m) => (
                            <Option key={m.key} value={m.key}>
                                {m.title}
                            </Option>
                        ))}
                    {contentType === "series" &&
                        seriesMaster.map((m) => (
                            <Option key={m.key} value={m.key}>
                                {m.title}
                            </Option>
                        ))}
                    {contentType === "songs" &&
                        songsMaster.map((m) => (
                            <Option key={m.key} value={m.key}>
                                {m.title}
                            </Option>
                        ))}
                </Select>

                <Row gutter={16}>
                    <Col span={8}>
                        {
                            contentType === "movies" && (
                                <Table dataSource={movies} rowSelection={getRowSelection("table1")}>
                                    <Column title="Name" dataIndex="title" key="title" align="center" />
                                </Table>
                            )
                        }

                        {
                            contentType === "series" && (
                                <Table dataSource={series} rowSelection={getRowSelection("table2")}>
                                    <Column title="Name" dataIndex="title" key="title" align="center" />
                                </Table>
                            )
                        }

                        {
                            contentType === "songs" && (
                                <Table dataSource={songs} rowSelection={getRowSelection("table4")}>
                                    <Column title="Name" dataIndex="title" key="title" align="center" />
                                </Table>
                            )
                        }
                    </Col>
                    <Col span={16}>
                        <Card title="Selected Items" style={{ position: "sticky", top: 20 }}>
                            {(() => {

                                // Determine data source, title, and tag color based on contentType
                                let selectedItems = [];
                                let title = "";
                                let tagColor = "";

                                if (contentType === "movies") {
                                    selectedItems = selectedMovies;
                                    title = "Movies";
                                    tagColor = "blue";
                                } else if (contentType === "series") {
                                    selectedItems = selectedSeries;
                                    title = "Series";
                                    tagColor = "green";
                                } else if (contentType === "songs") {
                                    selectedItems = selectedSongs;
                                    title = "Songs";
                                    tagColor = "purple";
                                }

                                return (
                                    <>
                                        {selectedItems.length > 0 ? (
                                            <div>
                                                <Title level={5}>
                                                    {title} <Tag color={tagColor}>{selectedItems.length}</Tag>
                                                </Title>
                                                <List
                                                    size="small"
                                                    bordered
                                                    dataSource={selectedItems}
                                                    renderItem={(item) => (
                                                        <List.Item>
                                                            <Text>{item.title}</Text>
                                                        </List.Item>
                                                    )}
                                                    style={{ maxHeight: "200px", overflowY: "auto" }}
                                                />
                                            </div>
                                        ) : (
                                            <Text type="secondary">No items selected</Text>
                                        )}
                                    </>
                                );
                            })()}
                        </Card>
                        <Button
                            type="primary"
                            size="large"
                            onClick={handleSubmit}
                            style={{ marginTop: 16, width: 90 }}
                        >
                            Submit
                        </Button>
                    </Col>

                </Row>
            </Space>
        </div>
    )
}

export default UploadContentToJio
